import { useEffect, useState } from 'react';

// UI only for now (user decision 2026-09-24): placeholder notifications from the spec, no api or notification model yet.
// Module-level store (same idea as Toast) so the header bell and the Notifications page share read/unread state.

export type NotificationCategory = 'approvals' | 'questions' | 'registry' | 'email' | 'hub' | 'security';
export type NotificationGroup = 'today' | 'yesterday' | 'week';

export interface NotificationItem {
    id: string;
    category: NotificationCategory;
    group: NotificationGroup;
    title: string;
    // full text for the page; short = the dropdown's shorter wording
    body: string;
    short: string;
    // relative time for the page / the dropdown
    time: string;
    shortTime: string;
    action: string;
    unread: boolean;
    danger?: boolean;
}

let items: NotificationItem[] = [
    { id: 'n1', category: 'approvals', group: 'today', title: 'Approval needed', time: '10 min ago', shortTime: '10 min ago', action: 'Review & Send', unread: true,
        body: '“Appendix 3Y – Change of Director\'s Interest Notice x2” is ready to email to 150 subscribers. Non price‑sensitive announcements wait for your approval.',
        short: '“Appendix 3Y – Change of Director\'s Interest” is ready to email to 150 subscribers.' },
    { id: 'n2', category: 'questions', group: 'today', title: 'New investor question', time: '2 h ago', shortTime: '2 h ago', action: 'Answer', unread: true,
        body: 'Brendan Taylor (verified holder, 120,000 shares): “When is the next drilling update expected at Gold Mountain?”',
        short: 'Brendan Taylor: “When is the next drilling update expected at Gold Mountain?”' },
    { id: 'n3', category: 'registry', group: 'today', title: 'Registry updated', time: '6:10 pm', shortTime: '6:10 pm', action: 'View Report', unread: true,
        body: '20 movements yesterday · 658,939 shares traded. 2 existing holders increased their holding.',
        short: '20 movements yesterday · 658,939 shares. 2 existing holders increased.' },
    { id: 'n4', category: 'email', group: 'yesterday', title: 'Campaign report ready', time: 'Yesterday, 9:00 am', shortTime: 'Yesterday', action: 'See Report', unread: false,
        body: '“171m @ 0.9g/t Gold Confirms Scale…” — 44.7% opened, 5.3% clicked after 7 days.',
        short: '“171m @ 0.9g/t Gold…” — 44.7% opened, 5.3% clicked after 7 days.' },
    { id: 'n5', category: 'hub', group: 'yesterday', title: 'Page saved as draft', time: 'Yesterday, 4:12 pm', shortTime: 'Yesterday', action: 'Open Page', unread: false,
        body: 'Wallace Turner saved “Gold Mountain project” on the Website Hub.',
        short: 'Wallace Turner saved “Gold Mountain project” on the Website Hub.' },
    { id: 'n6', category: 'hub', group: 'yesterday', title: 'New Website Hub sign‑up', time: 'Yesterday, 11:30 am', shortTime: 'Yesterday', action: 'View Contact', unread: false,
        body: 'Alexander Sample signed up and was matched to the registry (43,114 shares).',
        short: 'Alexander Sample signed up and was matched to the registry.' },
    { id: 'n7', category: 'questions', group: 'week', title: 'Question overdue', time: 'Mon, 1 Sep', shortTime: 'Mon', action: 'Answer', unread: false, danger: true,
        body: 'Dev Patel\'s question about the June cash position has waited more than 48 hours.',
        short: 'Dev Patel\'s question has waited more than 48 hours.' },
    { id: 'n8', category: 'approvals', group: 'week', title: 'Announcement published', time: 'Mon, 1 Sep', shortTime: 'Mon', action: 'View', unread: false,
        body: '“Appendix 3Y – Change of Director\'s Interest Notice x2” was synced from the ASX.',
        short: '“Appendix 3Y – Change of Director\'s Interest Notice x2” was synced from the ASX.' },
    { id: 'n9', category: 'security', group: 'week', title: 'New sign‑in to your account', time: 'Sun, 31 Aug', shortTime: 'Sun', action: 'Review', unread: false,
        body: 'Chrome on Windows · Perth, WA. If this wasn\'t you, secure your account.',
        short: 'Chrome on Windows · Perth, WA.' },
];

let listeners: ((items: NotificationItem[]) => void)[] = [];
const emit = () => listeners.forEach(l => l(items));

export const setRead = (id: string, read = true) => {
    items = items.map(x => x.id === id ? { ...x, unread: !read } : x);
    emit();
};

export const markAllRead = () => {
    items = items.map(x => ({ ...x, unread: false }));
    emit();
};

export const useNotifications = () => {
    const [list, setList] = useState<NotificationItem[]>(items);
    useEffect(() => {
        listeners.push(setList);
        return () => { listeners = listeners.filter(l => l !== setList); };
    }, []);
    return list;
};
